import React from 'react';
import {
    BodyLargeRegular,
    Button,
    CrossIcon,
    DisplayExtraSmall,
    ModalHeader
} from 'prospect-path-base';
import styled from 'styled-components';

const ButtonStack = styled.div`
  margin-top: 1rem;
  ${Button} {
    margin-bottom: 0.75rem;
    &:last-child {
        margin: 0;
    }
  }
`

const ProductSuccess = (setStep, closeProductModal) => (
    <div>
        <ModalHeader
            title={<DisplayExtraSmall>Success</DisplayExtraSmall>}
            close={<CrossIcon onClick={closeProductModal} />}
        />

        <BodyLargeRegular as="p">The product was successfully added to your team. You can manage your products from the products page.</BodyLargeRegular>

        <ButtonStack>
            <Button
                block
                size="small"
                onClick={() => window.open('/products', '_self')}
            >
                Finish
            </Button>
            <Button
                block
                color="secondary"
                size="small"
                onClick={() => setStep('ShowExistingProducts')}
            >
                Add another product
            </Button>
        </ButtonStack>
    </div>
);

export default ProductSuccess;
